if (!customElements.get('up-broderie')) {
  customElements.define(
    'up-broderie',

    class UpBorderie extends HTMLElement {
      constructor() {
        super();

        // Data
        this.fontsData = JSON.parse(this.querySelector('[type="application/json"]').textContent);

        // Static UI
        this.threadSelectors = this.querySelector('#up-broderie-selects-threads');
        this.fontSelectors = this.querySelector('#up-broderie-selects-fonts');
        this.input = this.querySelector('#up-broderie-text input');
        this.preview = this.querySelector('#up-broderie-preview');

        this.backupKey = this.dataset.backupId || '';
      }

      connectedCallback() {
        this.threadSelectors.addEventListener('change', (event) => {
          this.updateSelectionMetadata(event);
          this.updateColorPreview.bind(this)();
        });

        this.fontSelectors.addEventListener('change', (event) => {
          this.updateSelectionMetadata(event);
          this.updateFontPreview.bind(this)();
        });

        this.input.addEventListener('keyup', this.updateTextPreview.bind(this));

        this.initFromBackup();

        this.querySelector('.up-broderie-toggle input').addEventListener('change', (e) => {
          if (e.target.checked) {
            this.showForm();
          } else {
            this.hideForm();
          }
        });
      }

      showForm() {
        this.querySelector('.up-broderie-main').style.display = 'block';
        this.querySelector('.up-broderie-toggle input').setAttribute('checked', true);
      }

      hideForm() {
        this.querySelector('.up-broderie-main').style.display = 'none';
        this.querySelector('.up-broderie-toggle input').setAttribute('checked', false);
      }

      initFromBackup() {
        this.data = JSON.parse(localStorage.getItem(this.backupKey) || '{}');

        this.fontSelectors.querySelector(this.data.currentFont ? `#${this.data.currentFont}` : 'input')?.click();
        this.threadSelectors
          .querySelector(this.data.currentColor ? `input[data-color='${this.data.currentColor}']` : 'input')
          ?.click();

        if (this.data.currentText) {
          this.input.value = this.data.currentText;
          this.preview.textContent = this.data.currentText;

          this.updateTextPreview();
          this.showForm();
        }
      }

      saveData(key, value) {
        this.data[key] = value;
        this.setAttribute('data-' + key, value);

        localStorage.setItem(this.backupKey, JSON.stringify(this.data));
      }

      updateSelectionMetadata({ target }) {
        const { value, tagName } = target;
        if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue !== undefined) selectedSwatchValue.innerHTML = value;
        }
      }

      updateTextPreview() {
        this.saveData('currentText', this.input.value);
        this.preview.textContent = this.data.currentText;
      }

      updateFontPreview() {
        const currentFont = Array.from(this.fontSelectors.querySelectorAll('input')).find((radio) => radio.checked)
          .dataset.font;

        const currentFontName = Array.from(this.fontSelectors.querySelectorAll('input')).find((radio) => radio.checked)
          .value;

        this.saveData('currentFont', currentFont);
        this.saveData('currentFontName', currentFontName);

        this.preview.style.setProperty('--up-broderie-font', currentFont);
        this.preview.style.setProperty(
          '--up-broderie-font-size',
          this.fontsData[currentFont].size ? `${this.fontsData[currentFont].size}%` : '150%'
        );
      }

      updateColorPreview() {
        const currentColor = Array.from(this.threadSelectors.querySelectorAll('input')).find((radio) => radio.checked)
          .dataset.color;

        const currentColorName = Array.from(this.threadSelectors.querySelectorAll('input')).find((radio) => radio.checked)
          .value;

        this.saveData('currentColor', currentColor);
        this.saveData('currentColorName', currentColorName);

        this.preview.style.setProperty('--up-broderie-color', currentColor);
      }
    }
  );
}
